import { Alert, Box, Button, Container, Grid2 as Grid, Paper, Skeleton, Stack, Typography } from "@mui/material";
import { handleRetrieveForumCategories } from "../../../redux/public-slices/forum.slice";
import { Fragment, lazy, Suspense, useEffect, useState } from "react";
import SectionSkeleton from "../../../components/ui/SectionSkeleton";
import { showDialog } from "../../../redux/guest-slices/other.slice";
import { checkUserType, FILE_PATH_URI } from "../../../utils/helper";
import SkeletonImage from "../../../components/ui/SkeletonImage";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { GUEST_LOGIN } from "../../../utils/keywords";
import { useToast } from "../../../hooks/useToast";
import Images from "../Home/temp-data/Images";

const TopBannerB = lazy(() => import("../../../components/common/TopBannerB"));
const CtaSection = lazy(() => import("../../../components/ui/CtaSection"));

function Forum() {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const toast = useToast();
  const checkUser = checkUserType();
  const { loadings } = useSelector((state) => state.otherSlice);
  const navigate = useNavigate();
  const handleGetAll = (filters) => {
    dispatch(
      handleRetrieveForumCategories({
        limit: filters?.limit || 100,
        categoryId: filters?.categoryId || null,
      })
    )
      .unwrap()
      .then((data) => {
        setData(data);
      })
      .catch(() => { });
  };
  const handleLogin = () => {
    dispatch(showDialog(GUEST_LOGIN));
  };
  const handleCategoryClick = (categoryId, isBooked) => {
    if (!checkUser) {
      handleLogin();
    } else {
      const timeoutId = setTimeout(() => {
        if (!isBooked) {
          navigate(`/forum-category/${categoryId}`);
          toast.success("Followed Successfully");
        } else {
          toast.error("Already Followed");
        }
      }, 1000);

      return () => clearTimeout(timeoutId);
    }
  };

  useEffect(() => {
    handleGetAll();
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <Suspense fallback={<SectionSkeleton />}>
        <TopBannerB
          bannerImg={Images?.forumImg8}
          headline="You're Not Alone"
          subHeadline="Join discussions, get support, and grow together."
        />
      </Suspense>

      <Box sx={{ py: { xs: 5, lg: 10 } }}>
        <Container sx={{p:0}} maxWidth={false} fixed>
          <Grid container>
            <Grid size={{ xs: 12, xl: 10 }} mx="auto">
              <Box>
                <Grid container spacing={3}>
                  {loadings?.retrieveAll ? (
                    new Array(6).fill().map((_, i) => (
                      <Grid key={i} size={{ xs: 12, md: 6, lg: 4 }}>
                        <Paper
                          sx={{
                            p: 2.5,
                            border: "1px solid #f0f0f0",
                          }}
                          component={Stack}
                        >
                          <Skeleton
                            sx={{
                              mb: 1,
                              width: "100%",
                              height: "40px",
                              transform: "none",
                            }}
                            animation="wave"
                          />
                          <Box
                            sx={{
                              mb: 1,
                              width: "100%",
                              aspectRatio: "1/0.7",
                            }}
                          >
                            <Skeleton
                              sx={{
                                mb: 1,
                                width: "100%",
                                height: "100%",
                                transform: "none",
                              }}
                              animation="wave"
                            />
                          </Box>
                          <Grid
                            container
                            spacing={0.5}
                            justifyContent="space-between"
                          >
                            <Grid size={5}>
                              <Skeleton
                                sx={{
                                  mb: 1,
                                  width: "100%",
                                  height: "30px",
                                  transform: "none",
                                }}
                                animation="wave"
                              />
                            </Grid>
                            <Grid size={5}>
                              <Skeleton
                                sx={{
                                  mb: 1,
                                  width: "100%",
                                  height: "30px",
                                  transform: "none",
                                }}
                                animation="wave"
                              />
                            </Grid>
                          </Grid>
                        </Paper>
                      </Grid>
                    ))
                  ) : data?.records?.length === 0 ? (
                    <Grid size={12}>
                      <Alert
                        sx={{
                          fontSize: "20px",
                          fontWeight: "500",
                          alignItems: "center",
                          fontFamily: "Poppins",
                          ".MuiAlert-message": { p: "0" },
                          ".MuiAlert-icon": { fontSize: "28px" },
                        }}
                        color="error"
                        severity="error"
                      >
                        No Records Found!
                      </Alert>
                    </Grid>
                  ) : (
                    data?.records?.map((element, i) => (
                      <Grid key={i} size={{ xs: 12, md: 6, lg: 4 }}>
                        <Paper
                          sx={{
                            p: 2.5,
                            border: "1px solid #f0f0f0",
                          }}
                          component={Stack}
                        >
                          <Typography
                            sx={{
                              py: 1,
                              color: "white",
                              fontSize: "20px",
                              bgcolor: "black",
                              fontWeight: "600",
                              textAlign: "center",
                              textDecoration: "none",
                            }}
                            component={Link}
                            to={`/forum-category/${element?._id}`}
                          >
                            {element?.name}
                          </Typography>
                          <Box
                            sx={{
                              mb: 1,
                              width: "100%",
                              aspectRatio: "1/0.7",
                            }}
                            component={Link}
                            to={`/forum-category/${element?._id}`}
                          >
                            <SkeletonImage
                              src={FILE_PATH_URI + element?.banner?.path}
                            />
                          </Box>
                          <Grid container spacing={0.5}>
                            <Grid size="grow">
                              <Button
                                size="small"
                                variant="text"
                                disableRipple
                                LinkComponent={Link}
                                sx={{ color: "#272b41" }}
                              >
                                {" "}
                                {element?.forumCount} &nbsp; Topics
                              </Button>
                            </Grid>
                            <Grid size="grow" textAlign="end">
                              <Grid size="grow" textAlign="end">
                                {element?.isBooked ? (
                                  <Typography
                                    sx={{
                                      color: "black",

                                      textDecoration: "none",
                                    }}
                                    component={Link}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleCategoryClick(
                                        element?._id,
                                        element?.isBooked
                                      );
                                    }}
                                  >
                                    {element?.views} Followed
                                  </Typography>
                                ) : (
                                  <Typography
                                    sx={{
                                      color: "black",

                                      textDecoration: "none",
                                    }}
                                    component={Link}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleCategoryClick(
                                        element?._id,
                                        element?.isBooked
                                      );
                                    }}
                                  >
                                    {element?.views} Follow
                                  </Typography>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Paper>
                      </Grid>
                    ))
                  )}
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Suspense fallback={<SectionSkeleton />}>
        <CtaSection>
          <Typography variant="ctaNormal">
            Become a Part of Our Community
          </Typography>
          <Button
            variant="CtaButton"
            component={NavLink}
            to={checkUser ? `/${checkUser}/profile/add-forum` : "/login"}
          >
            Join Now
          </Button>
        </CtaSection>
      </Suspense>
    </Fragment>
  );
}

export default Forum;
